import React, { useContext, useState } from "react";

import { Tabs, Tab, Box } from "@material-ui/core";

import DynamicBanner from 'views/Dashboard/BannerUploader/BannerUploader';
import SignatureDynamicBanner from 'views/Dashboard/SignatureBannerUploader/SignatureBannerUploader';
import TargetDynamicBanner from 'views/Dashboard/TargetBanner/TargetBannerUploader';
import TierDynamicBanner from 'views/Dashboard/TierBannerUploader/TierBannerUploader';

import Context from 'context/context';


export default function BannerSetup() {

  const { state } = useContext(Context);

  const isHSD =
    state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental';


  // Maintain selected tab after browser back
  const [value, setValue] = useState(
    Number(sessionStorage.getItem("bannerTab")) || 0
  );


  const tabs = isHSD
    ? [
        {
          label: "Banner Repository & Preview",
          component: <DynamicBanner />
        },
        {
          label: "Signature & Preview",
          component: <SignatureDynamicBanner />
        },
        {
          label: "Tier & Preview",
          component: <TierDynamicBanner />
        },
        {
          label: "Target Banner Setup",
          component: <TargetDynamicBanner />
        }
      ]
    : [
        {
          label: "Banner Repository & Preview",
          component: <DynamicBanner />
        },
        {
          label: "Target Banner Setup",
          component: <TargetDynamicBanner />
        }
      ];


  const handleChange = (event, newValue) => {
    setValue(newValue);
    sessionStorage.setItem("bannerTab", newValue);
  };


  return (
    <Box>

      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="Banner Setup Tabs"
        TabIndicatorProps={{
          style: { backgroundColor: '#007bff' }
        }}
      >

        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
          />
        ))}

      </Tabs>


      <Box sx={{ p: 2 }}>
        {tabs[value]?.component}
      </Box>

    </Box>
  );
}